import { createSlice } from "@reduxjs/toolkit";
import { fetchMinistriesMenu, fetchIndicatorsMenu, fetchReportsMenu } from "./layoutsApi"; // Import the downloadFile thunk

interface UsersState {
    indicators: Array<any>;
    indicatorsMenu: any;
    reportsMenu: any;
    isLoading: boolean;
    error: any;
}

const initialState: UsersState = {
    indicators: [],
    indicatorsMenu: {},
    reportsMenu: {},
    isLoading: false,
    error: null,
};

const indicatorsSlice = createSlice({
    name: "layoutData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchUsers actions
            .addCase(fetchMinistriesMenu.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchMinistriesMenu.fulfilled, (state, action) => {
                state.isLoading = false;
                state.indicators = action?.payload?.data || [];
            })
            .addCase(fetchMinistriesMenu.rejected, (state, action) => {
                console.log('error', action.payload);
                state.isLoading = false;
            })
            // Handle fetchIndicatrsMenu actions
            .addCase(fetchIndicatorsMenu.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchIndicatorsMenu.fulfilled, (state, action) => {
                state.isLoading = false;
                state.indicatorsMenu = action?.payload?.data || [];
            })
            .addCase(fetchIndicatorsMenu.rejected, (state, action) => {
                console.log('error', action.payload);
                state.isLoading = false;
            })

             // Handle fetchIndicatrsMenu actions
             .addCase(fetchReportsMenu.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchReportsMenu.fulfilled, (state, action) => {
                state.isLoading = false;
                state.reportsMenu = action?.payload?.data || [];
            })
            .addCase(fetchReportsMenu.rejected, (state, action) => {
                console.log('error', action.payload);
                state.isLoading = false;
            })

    },
});

export default indicatorsSlice.reducer;
